import store from "store2"

import grid from './grid/grid'

export default function(o, done){

  var lang = o.store('lang')

  var projectLabel = o.util.getTranslation(o, 'project')
  var storiesLabel = o.util.getTranslation(o, 'stories')
  var moreStoriesLabel = o.util.getTranslation(o, 'moreStories')
  var minLabel = o.util.getTranslation(o, 'min')

  o.data.movies(o, function(moviesData){

    document.title = `Open Memory Box | ${storiesLabel}`

    var results =
      _.map(moviesData, function(movie){

        var title = movie[lang]
        var titleSlug = Slug(movie.en)
        var project = movie.project
        var duration = movie.duration
        var min = duration.split(':')[1] * 1

        var imageFile = movie.covers[MaxResolution]
        var imageUrl = o.util.getUrl('movieThumb',MaxResolution) + imageFile

        var result = {
          label: title,
          sublabel: `${projectLabel} ${project} / ${min} ${minLabel}`,
          titleSlug: titleSlug,
          imageUrl: imageUrl,
        }

        return result

      })

    var gridDiv = grid(o, results)

    var div = $('<div>')
    .css(o.mainDivCss)
    .addClass('iphoneNavbarFixTop')
    .addClass('iphoneNavbarFixBottom')  
    .append([

      o.component.menu(o)
      .css({
        flex: '0 0 auto',
        width: '100%',
        zIndex: 1,
      }),

      gridDiv
      .css({
        flex: '0 1 auto',
        width: '100%',
        overflowY: 'auto',
        '-webkit-overflow-scrolling': 'touch',
        minHeight: 0,
        zIndex: 1,
      }),

      $('<div>')
      .css({
        flex: '0 0 auto',
        width: '100%',
        padding: '0.9rem',
        zIndex: 1,
        textAlign: 'center',
        fontSize: o.fontSizeDef.xs,
        lineHeight: '1.1rem',
        textTransform: 'none',
      })
      .html(moreStoriesLabel),

      $('<div>')
      .css({
        flex: '1 1 auto',
        width: '100%',
      })

    ])

    var observer =
      new MutationObserver(function(){
        if (document.body.contains(div[0])){

          observer.disconnect()

          gridDiv.update()

          if(o.store('storiesScrollTop')){
            gridDiv.scrollTop(o.store('storiesScrollTop'))
          }

        }
      })

    observer.observe(document.body, {childList: true});

    done(div)

  })

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/stories/stories.js